.pageType {
  text-transform: uppercase;
  font-weight: var(--font-weight-black);
}

.updated {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .initials {
    margin-left: var(--space-s);
  }
}

.row {
  cursor: pointer;

  td {
    border-top: 1px solid var(--color-svp-grey);

    &:first-child {
      position: relative;

      &::before {
        content: "templates";
        position: absolute;
        top: -11px;
        line-height: 20px;
        left: var(--space-m);
        padding: 0 var(--space-xs);
        background-color: #fff;
        text-transform: uppercase;
        color: var(--color-svp-grey);
        font-weight: var(--font-weight-bold);
      }
    }
  }

  & + .row td {
    border-top: 0;

    &:first-child::before {
      content: none;
    }
  }
}
